import React from 'react';
import './Plandetails.css';

const plans = [
  {
    name: 'Basic Plan',
    priceMonthly: '$9.99/mo',
    priceYearly: '$99.99/yr',
    description: 'Perfect for individuals just getting started.',
    audience: 'For personal use or testing projects.',
    features: ['10GB Storage', '1 User', 'Email Support'],
  },
  {
    name: 'Light Plan',
    priceMonthly: '$29.99/mo',
    priceYearly: '$299.99/yr',
    description: 'Ideal for small teams and growing startups.',
    audience: 'Best for teams needing shared access.',
    features: ['50GB Storage', '5 Users', 'Priority Email Support'],
  },
  {
    name: 'Pro Plan',
    priceMonthly: '$59.99/mo',
    priceYearly: '$599.99/yr',
    description: 'Full power for larger teams and businesses.',
    audience: 'Great for scale-ups and agencies.',
    features: ['200GB Storage', 'Unlimited Users', '24/7 Phone & Email Support'],
  },
];

function Plandetails() {
  return (
    <section className="plan-section">
      <h2 className="plan-title">Choose Your Plan</h2>
      <p className="plan-subtitle">Flexible pricing options for teams and individuals.</p>

      <div className="plan-description">
        Whether you're just getting started or scaling your business, our plans are designed to grow with you. Pick the one that fits your needs.
      </div>

      <div className="plan-container-horizontal">
        {plans.map((plan, idx) => (
          <div key={plan.name} className={`plan-box ${idx === 1 ? 'plan-recommended' : ''}`}>
            {idx === 1 && <div className="recommended-badge">Most Popular</div>}
            <h3 className="plan-name">{plan.name}</h3>
            <p className="plan-price">{plan.priceMonthly}</p>
            <p className="plan-desc">{plan.description}</p>
            <p className="plan-audience">{plan.audience}</p>
            <ul className="plan-features">
              {plan.features.map((feature, index) => (
                <li key={index} className="feature-item">
                  ✓ {feature}
                </li>
              ))}
            </ul>
            <button className="plan-button">Select Plan</button>
          </div>
        ))}
      </div>

      <p className="plan-footer-text">No hidden fees. Cancel anytime. Upgrade or downgrade as you grow.</p>
    </section>
  );
}

export default Plandetails;
